import { createReducer } from '@reduxjs/toolkit';
import { TYPES } from '../../common/constants';

const setSearch = ( state, { payload } ) => {
  return payload
};

const clearSearch = (state) =>{
  return ''
}

const initialState = '';

export default createReducer(initialState, {
  [TYPES.SET_SEARCH]: setSearch,
  [TYPES.CLEAR_SEARCH]: clearSearch
});
